(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.setHeaderHeight();
      window.addEventListener('resize', this.setHeaderHeight.bind(this));

      // Hueco que ocupa el sitio del header mientras está en position:fixed
      // (hide/reveal). Sin él, la página sube --header-height px al pasar a
      // fixed y baja de golpe al volver arriba (reset): el "saltito" al subir.
      if (!this.header.nextElementSibling || !this.header.nextElementSibling.classList.contains('header-sticky-spacer')) {
        this.spacer = document.createElement('div');
        this.spacer.className = 'header-sticky-spacer';
        this.spacer.setAttribute('aria-hidden', 'true');
        this.header.after(this.spacer);
      }

      // NOTE: We intentionally do NOT promote the header to position:fixed on load.
      // The CSS already sets `.section-header { position: sticky; top: 0; }` which
      // keeps the header pinned at the top of the viewport while preserving its
      // space in the document flow — preventing a layout shift on hard refresh.
      // The sticky→fixed promotion only happens during scroll inside hide()/reveal(),
      // when it's actually needed for the translateY(-100%) hide animation.

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.scrollDownStart = null;       // where downward scroll began
      this.hideThreshold = 800;          // px desktop: scroll down before hiding
      this.hideThresholdMobile = 60;     // px mobile: scroll down before hiding (responsive auto-hide)

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const isMobile = window.innerWidth < 750;
      const threshold = isMobile ? this.hideThresholdMobile : this.hideThreshold;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Don't hide/show header while search modal is open (prevents scroll lock conflicts)
      if (document.body.classList.contains('search-open')) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      // Scrolling DOWN — only hide after scrolling hideThreshold px downward
        if (this.preventHide) return;
        if (this.scrollDownStart === null) this.scrollDownStart = scrollTop;
        if (scrollTop - this.scrollDownStart >= threshold) {
          requestAnimationFrame(this.hide.bind(this));
        }

      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        // Reset the downward-scroll tracker when user scrolls back up
        this.scrollDownStart = null;
        // Scrolling UP — reveal the sticky header with animation
        this.header.classList.add('scrolled-past-header');
        this.header.querySelector('.header-wrapper').classList.add('gradient');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }

      } else if (scrollTop <= this.headerBounds.top) {
        // Back at the top — restore original header
        this.header.classList.remove('scrolled-past-header');
        this.header.querySelector('.header-wrapper').classList.remove('gradient');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      // Don't hide header while mobile search is open — it would close the modal and cause a loop
      if (document.body.classList.contains('search-open')) return;
      // Don't hide header while menu drawer is open
      if (document.body.classList.contains('menu-open')) return;
      // Always hide when scrolling down (even if data-sticky-type="always")
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.header.classList.remove('animate');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      // Slide in from top with smooth animation
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
